import { render, staticRenderFns } from "./SubjectSearchResultView.vue?vue&type=template&id=37a2a1f0&scoped=true"
import script from "./SubjectSearchResultView.vue?vue&type=script&lang=js"
export * from "./SubjectSearchResultView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a2a1f0",
  null
  
)

export default component.exports